// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".darker[data-v-c066d9f0] {\n  background: #000000d9;\n}\n.container-size[data-v-c066d9f0] {\n  max-width: 800px;\n  margin: 0 auto;\n}\n.bsd-disabled[data-v-c066d9f0] {\n  background-color: gray;\n}\n@media only screen and (max-width: 768px) {\n.container-size[data-v-c066d9f0] {\n    max-width: 768px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
